'use strict';

export const fetchRequest = (url, cb, onError) => {
  const data = url.data || {};
  return fetch(url.data ? url.url : url, data)
    .then(response => {
      if (response.status !== 200) {
        return onError();
      }
      return response.json();
    })
    .then(
      response =>
        new Promise(resolve => {
          resolve(cb(response));
        })
    )
    .catch(error => {
      if (onError) onError(error);
    });
};

export const buidlURL = (location, params) => {
  const url = new URL(location);

  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      url.searchParams.append(key, params[key]);
    }
  }

  return encodeURI(url);
};

export const loadFetch = (commit, text, options, body) => {
  commit('setError');
  commit('setLoading', { text });
  const url = buidlURL(GATEWAY, options);
  return fetchRequest(
    url,
    response => body(response),
    error => commit('setError', error)
  ).then(() => commit('setLoading', { text, set: false }));
};

export const GATEWAY = 'https://well.ru/local/modules/well.modules/gateway.php';

const pressed = [];
let lastID = 0;
export const invokeOnce = (callback, timeout) => {
  const localID = lastID++;
  pressed.push(localID);

  return setTimeout(() => {
    const localPressed = [...pressed];
    const go = localPressed.length === 1 && localPressed[0] === localID;
    pressed.splice(pressed.indexOf(localID), 1);
    return go ? callback() : false;
  }, timeout);
};

export const dateToString = date =>
  `${('0' + date.getDate()).slice(-2)}.${('0' + (date.getMonth() + 1)).slice(
    -2
  )}.${date.getFullYear()}`;

export const i18n = {
  month: [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь'
  ],
  day: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
  errors: {
    'Access denied': 'Доступ запрещен',
    'Error getting Request Id': 'Поиск не удался, неверно заполнены поля',
    'No hotel photos': 'Фото отеля отсутствует'
  },
  loading: {
    Initialization: 'Инициализирую',
    'Getting countries': 'Открываю страны',
    Searching: 'Ищу туры',
    'Getting result': 'Загружаю туры',
    'Getting hotel info': 'Узнаю об отеле',
    'Actualizing tour': 'Уточняю актуальность тура',
    'Actualizing tour details': 'Уточняю актуальность цен тура'
  }
};

export const meal = [
  { id: 0, name: 'Любое' },
  { id: 2, name: 'Без питания' },
  { id: 3, name: 'BB - Только завтрак' },
  { id: 4, name: 'HB - Завтрак, Ужин' },
  { id: 5, name: 'FB - Полный Пансион' },
  { id: 7, name: 'AI - Все Включено' },
  { id: 9, name: 'UAI - Ультра Все Включено' }
];

export const rating = [
  { id: 0, name: 'Любой' },
  { id: 2, name: 'Больше 3' },
  { id: 3, name: 'Больше 3.5' },
  { id: 4, name: 'Больше 4' },
  { id: 5, name: 'Больше 4.5' }
];

export const getLocaleDate = date => {
  return [
    date.getDate(),
    i18n.month[date.getMonth()].slice(0, 3).toLowerCase()
  ].join(' ');
};

export const isEmpty = obj =>
  Object.entries(obj).length === 0 && obj.constructor === Object;

export const reachGoal = (id, eventName) => {
  if (typeof window.ym === 'function') window.ym(id, 'reachGoal', eventName);
  // else console.log('Install fresh YM counter');
};
